import type { Tab } from "../../shared/types/tab.type";

export const AmlAlertsOrderReportTableHeadings = [
  "fileName",
  "status",
  "orderedBy",
  "requestedDate",
  "expiryDate",
  "criteria",
  "decision",
];

export const AuditsReportTableHeadings = [
  "fileName",
  "status",
  "orderedBy",
  "requestedDate",
  "expiryDate",
  "startDateEndDate",
];

export const AuditsReportCriteriaTableHeadings = [
  "profile",
  "category",
  "subCategory",
  "action",
  "user",
  "startDateEndDate",
];

export const AmlScreeningOrderHistoryTableHeading = [
  "fileName",
  "requestedDate",
  "requestedBy",
  "expiryDate",
  "fileStatus",
];

export const MonitorSearchResultsTableHeadings = [
  "fileName",
  "requestedDate",
  "requestedBy",
  "expiryDate",
  "searchTerm",
  "fileStatus",
];

export const ProfilesExportTableHeadings = [
  "fileName",
  "requestedDate",
  "requestedBy",
  "expiryDate",
  "fileStatus",
];

export const ReportsTabs = {
  alerts: "aml-alerts",
  screenings: "aml-screenings",
  monitorSearchResults: "monitor-search-results",
  profiles: "profiles",
  audits: "audits",
};

export const ReportTypes = {
  amlAlert: "amlAlert",
  amlScreening: "amlScreening",
  audit: "audit",
  monitorSearch: "monitorSearch",
  profilesExport: "ProfilesExport",
};

export const ReportTabValues: Tab[] = [
  {
    id: "aml-alerts",
    name: "amlAlert",
    label: "reports.tabs.amlAlerts",
    noOfItems: 0,
  },
  {
    id: "aml-screenings",
    name: "amlScreen",
    label: "reports.tabs.amlScreenings",
    noOfItems: 0,
  },
  {
    id: "monitor-search-results",
    name: "monitorSearch",
    label: "reports.tabs.monitorSearch",
    noOfItems: 0,
  },
  {
    id: "profiles",
    name: "ProfilesExport",
    label: "reports.tabs.profiles",
    noOfItems: 0,
  },
  {
    id: "audits",
    name: "audit",
    label: "reports.tabs.audits",
    noOfItems: 0,
  },
];

export const ReportConflict = "ReportConflict";
